
import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'CssPreloader',
})
export default class CssPreloader extends Vue {}
